const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
function generateString(length) {
  let result = ' ';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

$('#offer-form').on('submit', function(e) {

    e.preventDefault();
  
  	var refid = $(this).find('input[type="submit"]').attr('id');
    
  	var offermobile = $(this).find('.tel-no').val();
  	var visitorId = generateString(10);
  	var creativeId = refid;
  
    $("#"+refid+'-notice').text('');
	$("#"+refid+'-notice').removeClass('request-success');
    $("#"+refid+'-notice').removeClass('request-fail');
  
	$.ajax({
    
      //url: "https://firesidedigital.online/shopify-attentive-api/index.php",
      url: "https://sdjax.com/shopify-attentive-api/index.php",
	  method: "POST",
	  contentType: "text/plain",
      data: "{\"phone\":\""+offermobile+"\"}",
      dataType: "text",
      success: function (res)
 	  {
        var returnres = JSON.parse(res);
        displayResponse(returnres,refid);
      },
      error: function (xhr, status, error)
      {
        var returnres = JSON.parse(xhr.responseText);
        displayResponse(returnres,refid);
      }
	});
  return false;
});

/* end Sign up for text. */

/* Sign up for email. */

$('#offer-form-email').on('submit', function(e) {

    e.preventDefault();
  
  	var refid = $(this).find('input[type="submit"]').attr('id');
    
  	var offeremail = $(this).find('.newsletter').val();
  	var visitorId = generateString(10);
  	var creativeId = refid;
  
    $("#"+refid+'-notice').text('');
	$("#"+refid+'-notice').removeClass('request-success');
    $("#"+refid+'-notice').removeClass('request-fail');
  
	$.ajax({
    
      url: "https://firesidedigital.co/shopify-attentive-api/index.php",
	  method: "POST",
	  contentType: "text/plain",
      data: "{\"email\":\""+offeremail+"\",\"visitorId\":\""+visitorId+"\",\"creativeId\":\""+creativeId+"\"}",
      dataType: "text",
      success: function (res)
 	  {
        var returnres = JSON.parse(res);
        displayResponse(returnres,refid);
      },
      error: function (xhr, status, error)
      {
        var returnres = JSON.parse(xhr.responseText);
        displayResponse(returnres,refid);
      }
	});
  return false;
});

/* End Sign up for email. */

function displayResponse(returnres,refid){
    if ($.trim(returnres.status) != 'false') {
          $("#"+refid+'-notice').text($.trim(returnres.message));
          $("#"+refid+'-notice').addClass('request-success');  
      }
      else {
          $("#"+refid+'-notice').text($.trim(returnres.message));
          $("#"+refid+'-notice').addClass('request-fail');
      }
}
$(".tel-no").focus(function() {
    $(this).attr('placeholder', '(###) ###-####');
}).blur(function() {
    $(this).attr('placeholder', 'Cell Phone');
});
$( ".tel-no" ).keypress(function() {
    var text_id = $(this).attr('id');
	document.getElementById(text_id).addEventListener('input', function (e) {
   		var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  		e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
	});  
});

$(document).off('submit.shefitSizing', '#size-chart-form').on('submit.shefitSizing', '#size-chart-form', function(e) {
    var $form = $(this);
    var $scope = $form.closest('modal-dialog');
    if (!$scope.length) $scope = $form.parent();
    e.preventDefault();
    $scope.find('center.size-chart-results').show();
    var ribsize = $form.find('#ribsize').val();
    var cupsize = $form.find('#cupsize').val();
    $scope.find('#final-fit-size').text('Use your bust and rib-cage measurements in the chart above to find your starting size. Need help? Ask a fit expert.');
    $scope.find('.fit_3.two-size-content').hide();

    if (!ribsize || !cupsize || ribsize.toUpperCase() == 'BAND' || cupsize.toUpperCase() == 'CUP') {
        $scope.find('#final-fit-size').text('Please select your band and cup size.');
        $scope.find('.fit_3.two-size-content').hide();

    } else {

        if (
            ((ribsize == '28' || ribsize == '30') && (cupsize == 'A' || cupsize == 'B')) ||
            ((ribsize == '32' || ribsize == '34') && cupsize == 'A')
        ) {
            $scope.find('#final-fit-size').text('XS');

        } else if (
            (ribsize == '28' && (cupsize == 'C' || cupsize == 'D')) ||
            (ribsize == '32' && cupsize == 'B')
        ) {
            $scope.find('#final-fit-size').text('XS or Small');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '28' && cupsize == 'DD(E)') ||
            (ribsize == '30' && (cupsize == 'C' || cupsize == 'D')) ||
            (ribsize == '34' && cupsize == 'B')
        ) {
            $scope.find('#final-fit-size').text('Small');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '28' && cupsize == 'DDD(F)') ||
            ((ribsize == '30' || ribsize == '32') && cupsize == 'DD(E)') ||
            (ribsize == '32' && cupsize == 'D') ||
            ((ribsize == '32' || ribsize == '34') && cupsize == 'C') ||
            (ribsize == '36' && (cupsize == 'A' || cupsize == 'B'))
        ) {
            $scope.find('#final-fit-size').text('Small or Medium');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            ribsize == '30' && (cupsize == 'DDD(F)' || cupsize == 'G')
        ) {
            $scope.find('#final-fit-size').text('Medium');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '30' && cupsize == 'H') ||
            (ribsize == '32' && cupsize == 'DDD(F)') ||
            (ribsize == '34' && cupsize == 'D') ||
            (ribsize == '36' && cupsize == 'C')
        ) {
            $scope.find('#final-fit-size').text('Medium or Luxe');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            ribsize == '30' && cupsize == 'I'
        ) {
            $scope.find('#final-fit-size').text('Luxe');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '32' && (cupsize == 'G' || cupsize == 'H')) ||
            (ribsize == '34' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)')) ||
            (ribsize == '36' && (cupsize == 'D' || cupsize == 'DD(E)')) ||
            (ribsize == '38' && (cupsize == 'B' || cupsize == 'C'))
        ) {
            $scope.find('#final-fit-size').text('LUXE or 1LUXE');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '32' && cupsize == 'I') ||
            (ribsize == '34' && cupsize == 'H') ||
            (ribsize == '36' && cupsize == 'DDD(F)') ||
            (ribsize == '38' && (cupsize == 'D' || cupsize == 'DD(E)')) ||
            (ribsize == '40' && (cupsize == 'B' || cupsize == 'C')) ||
            (ribsize == '42' && cupsize == 'B')
        ) {
            $scope.find('#final-fit-size').text('1LUXE or 2LUXE');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            ribsize == '34' && cupsize == 'G'
        ) {
            $scope.find('#final-fit-size').text('1LUXE');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '34' && cupsize == 'I') ||
            (ribsize == '36' && cupsize == 'G')
        ) {
            $scope.find('#final-fit-size').text('2LUXE');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '36' && (cupsize == 'H' || cupsize == 'I')) ||
            (ribsize == '38' && cupsize == 'DDD(F)') ||
            (ribsize == '40' && (cupsize == 'D' || cupsize == 'DD(E)')) ||
            (ribsize == '42' && cupsize == 'C')
        ) {
            $scope.find('#final-fit-size').text('2LUXE or 3LUXE');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            ribsize == '38' && cupsize == 'G'
        ) {
            $scope.find('#final-fit-size').text('3LUXE');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '38' && cupsize == 'H') ||
            (ribsize == '40' && (cupsize == 'DDD(F)' || cupsize == 'G')) ||
            (ribsize == '42' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'D')) ||
            (ribsize == '44' && (cupsize == 'C' || cupsize == 'D'))
        ) {
            $scope.find('#final-fit-size').text('3LUXE or 4LUXE');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            ribsize == '38' && cupsize == 'I'
        ) {
            $scope.find('#final-fit-size').text('4LUXE');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '40' && cupsize == 'H') ||
            (ribsize == '42' && cupsize == 'G') ||
            (ribsize == '44' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)'))
        ) {
            $scope.find('#final-fit-size').text('4LUXE/5LUXE');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '40' && cupsize == 'I') ||
            (ribsize == '42' && cupsize == 'H') ||
            (ribsize == '46' && cupsize == 'C')
        ) {
            $scope.find('#final-fit-size').text('5LUXE');
            $scope.find('.fit_3.two-size-content').hide();

        } else if (
            (ribsize == '42' && cupsize == 'I') ||
            (ribsize == '44' && (cupsize == 'G' || cupsize == 'H')) ||
            (ribsize == '46' && (cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'D'))
        ) {
            $scope.find('#final-fit-size').text('5LUXE or 6LUXE');
            $scope.find('.fit_3.two-size-content').show();

        } else if (
            (ribsize == '44' && cupsize == 'I') ||
            (ribsize == '46' && (cupsize == 'G' || cupsize == 'H' || cupsize == 'I')) ||
            (ribsize == '48' && (cupsize == 'C' || cupsize == 'D' || cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'G' || cupsize == 'H' || cupsize == 'I')) ||
            (ribsize == '50' && (cupsize == 'D' || cupsize == 'DD(E)' || cupsize == 'DDD(F)' || cupsize == 'G' || cupsize == 'H' || cupsize == 'I'))
        ) {
            $scope.find('#final-fit-size').text('6LUXE');
            $scope.find('.fit_3.two-size-content').hide();
        }

    }
});

$(document).off('submit.shefitSizing', '#bust-rib-size-chart-form').on('submit.shefitSizing', '#bust-rib-size-chart-form', function(e) {
    var $form = $(this);
    var $scope = $form.closest('modal-dialog');
    if (!$scope.length) $scope = $form.parent();
  e.preventDefault();
  	$scope.find('center.bust-size-chart-results').show();
  	var bustsize = $form.find('#bustsize').val();
  	var ribcagesize = $form.find('#ribcagesize').val();

//alert("bustsize==>"+bustsize);
//alert("ribcagesize==>"+ribcagesize);
  
   if(bustsize =='Bust' || ribcagesize == 'Rib'){
    $scope.find('#bust-final-fit-size').text('Please Select Bust and Rib Cage Size');
    
  }
  else {
    if(((bustsize == '29' || bustsize == '31') && (ribcagesize == '22' || ribcagesize == '25' || ribcagesize == '26' || ribcagesize == '27')) ) {
      $scope.find('#bust-final-fit-size').text('XSmall');
    }
    else if(((bustsize == '32' || bustsize == '35') && (ribcagesize == '25' || ribcagesize == '26' || ribcagesize == '27' || ribcagesize == '29' || ribcagesize == '31'  || ribcagesize == '32')) ) {
      $scope.find('#bust-final-fit-size').text('Small');
    }
    else if(((bustsize == '35' || bustsize == '38') && (ribcagesize == '26' || ribcagesize == '27' || ribcagesize == '29' || ribcagesize == '31'  || ribcagesize == '32' || ribcagesize == '33.5')) ) {
      $scope.find('#bust-final-fit-size').text('Medium');
    }
    else if(((bustsize == '38' || bustsize == '40') && (ribcagesize == '29' || ribcagesize == '31'  || ribcagesize == '32' || ribcagesize == '33.5' || ribcagesize == '35.5' || ribcagesize == '36')) ) {
      $scope.find('#bust-final-fit-size').text('Luxe');
    }
    else if(((bustsize == '40' || bustsize == '42') && (ribcagesize == '31'  || ribcagesize == '32' || ribcagesize == '33.5' || ribcagesize == '35.5' || ribcagesize == '36' || ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38')) ) {
      $scope.find('#bust-final-fit-size').text('1Luxe');
    }
    else if(((bustsize == '42' || bustsize == '44') && (ribcagesize == '32' || ribcagesize == '33.5' || ribcagesize == '35.5' || ribcagesize == '36' || ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40')) ) {
      $scope.find('#bust-final-fit-size').text('2Luxe');
    }
    else if(((bustsize == '44' || bustsize == '46') && (ribcagesize == '35.5' || ribcagesize == '36' || ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43')) ) {
      $scope.find('#bust-final-fit-size').text('3Luxe');
    }
    else if(((bustsize == '46' || bustsize == '49') && (ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43' || ribcagesize == '44')) ) {
      $scope.find('#bust-final-fit-size').text('4Luxe');
    }
    else if(((bustsize == '49' || bustsize == '52') && (ribcagesize == '37' || ribcagesize == '37.5' || ribcagesize == '38' || ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43' || ribcagesize == '44' || ribcagesize == '47.5')) ) {
      $scope.find('#bust-final-fit-size').text('5Luxe');
    }
    else if(((bustsize == '52' || bustsize == '55') && (ribcagesize == '38.5' || ribcagesize == '40' || ribcagesize == '43' || ribcagesize == '44' || ribcagesize == '47.5' || ribcagesize == '49.5')) ) {
      $scope.find('#bust-final-fit-size').text('6Luxe');
    }
    else {
      $scope.find('#bust-final-fit-size').text('No Size in This Range');
    }
  }
});

$('.accordion-common').click(function(e123) {
  	e123.preventDefault();
    var $this = $(this);
    $this.next().slideToggle(350);
     $this.next().toggleClass('accordion-tab-active');
});

var acc = document.getElementsByClassName("accordion-title");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("accordion-active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
  
  $(".fitting-pages a").click(function() {
    const clink = jQuery(this).attr('href');
    jQuery('html, body').animate({
        scrollTop: $(clink).offset().top - 100
    }, 2000);
  });
// Begin tabbed content script

$(document).ready(function() {
$('#tabs li a:not(:first)').addClass('inactive');
$('.tabcontainer').hide();
$('.tabcontainer:first').show();
$('#tabs li a').click(function(){
  var t = $(this).attr('id');

  if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('#tabs li a').addClass('inactive');           
    $(this).removeClass('inactive');

    $('.tabcontainer').hide();
    $('#'+ t + 'C').fadeIn('slow');
 }
});
});
/*
$(document).ready(function() {    

$('#tabs li a:not(:first)').addClass('inactive');
$('.container').hide();
$('.container:first').show();
$('#tabs li a').click(function(){
    var t = $(this).attr('href');
    $('#tabs li a').addClass('inactive');        
    $(this).removeClass('inactive');
    $('.container').hide();
    $(t).fadeIn('slow');
    return false;
})

if($(this).hasClass('inactive')){ //this is the start of our condition 
    $('#tabs li a').addClass('inactive');         
    $(this).removeClass('inactive');
    $('.container').hide();
    $(t).fadeIn('slow');    
}

});
*/

$(document).ready(function() {

  $('.soft-scroll-to-section').on('click', function(e) {
    e.preventDefault();

    var selector = $(this).attr('href');
    scrollToSection(selector);
  });

  function scrollToSection(selector) {
    var target = $(selector);
    if (!target.length) return;

    var y = target.offset().top;

    $('html, body').animate({
      scrollTop: y
    }, 600);
  }

});

document.addEventListener('DOMContentLoaded', () => {
  const targetNode = document.querySelector('.custom-header__main');

  if (!targetNode) return;

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {

      // Solo reaccionar a cambios en el div específico
      if (
        mutation.type !== 'childList' ||
        !mutation.target.matches?.('div.predict-placement.wair-css')
      ) {
        continue;
      }

      console.log('Mutación detectada en el contenedor correcto');

      const button = mutation.target.querySelector(
        'button[type="button"]'
      );

      if (!button) return;

      const buttonText = button.textContent.trim();
      if (!buttonText) return;

      const sizeLink = document.querySelector(
        '.fdp-find-my-size.product-selector__size-link'
      );

      if (!sizeLink) return;

      const span = sizeLink.querySelector('span');
      if (!span) return;

      if (span.textContent.trim() !== buttonText) {
        span.textContent = buttonText !== 'Size Quiz' ? buttonText : 'Find My Size';

        if (buttonText !== 'Size Quiz') {
          sizeLink.querySelector('svg')?.classList.add('hidden');
          sizeLink.querySelector('svg.wair-btn-badge')?.classList.remove('hidden');
        }else{
          sizeLink.querySelector('svg')?.classList.remove('hidden');
          sizeLink.querySelector('svg.wair-btn-badge')?.classList.add('hidden');
        }
        

      }
    }
  });


  observer.observe(targetNode, {
    childList: true,
    subtree: true,
    characterData: true
  });
});

// ---------------------------------------------------------------------------
// Page-template PDP swatch: dynamic product swap via Section Rendering API
// ---------------------------------------------------------------------------
(function () {
  function initPageSwatches() {
    document.addEventListener('click', function (e) {
      const swatch = e.target.closest('.js-page-pdp-swatch');
      if (!swatch) return;

      const productHandle = swatch.dataset.productHandle;
      if (!productHandle) {
        console.warn('[page-pdp-swatch] Swatch found but missing data-product-handle');
        return;
      }

      const wrapper = swatch.closest('[data-pdp-section-wrapper]');
      if (!wrapper) {
        console.warn('[page-pdp-swatch] Could not find [data-pdp-section-wrapper] ancestor');
        return;
      }

      const sectionId = wrapper.dataset.sectionId;
      if (!sectionId) {
        console.warn('[page-pdp-swatch] Missing sectionId on wrapper');
        return;
      }

      // Skip if already showing this product
      const currentHandle = wrapper.dataset.activeHandle;
      if (currentHandle && currentHandle === productHandle) return;

      e.preventDefault();

      console.log('[page-pdp-swatch] Fetching product:', productHandle, '| section:', sectionId);

      // Visual feedback: dim the wrapper during fetch
      wrapper.style.opacity = '0.5';
      wrapper.style.pointerEvents = 'none';

      // Fetch section rendered in the context of the target product URL.
      // This makes `product` available in Liquid, overriding section.settings.product.
      const fetchUrl = '/products/' + encodeURIComponent(productHandle) + '?sections=' + encodeURIComponent(sectionId);

      fetch(fetchUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Section fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          console.log('[page-pdp-swatch] Response keys:', Object.keys(data));

          const html = data[sectionId];
          if (!html) {
            console.error('[page-pdp-swatch] Section key "' + sectionId + '" not found. Available keys:', Object.keys(data));
            throw new Error('Section not found in response');
          }

          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newWrapper = doc.querySelector('[data-pdp-section-wrapper]');

          if (newWrapper) {
            const renderedHandle = newWrapper.dataset.activeHandle || productHandle;
            console.log('[page-pdp-swatch] Swapping content. Requested:', productHandle, '| Rendered:', renderedHandle);
            if (renderedHandle !== productHandle) {
              console.warn('[page-pdp-swatch] Product mismatch — Liquid may not be reading request.query_string. Check that pdp_product param is reaching the section.');
            }
            wrapper.innerHTML = newWrapper.innerHTML;
            // Preserve data attributes so future clicks still work
            wrapper.dataset.sectionId = newWrapper.dataset.sectionId || sectionId;
            wrapper.dataset.activeHandle = renderedHandle;
          } else {
            console.warn('[page-pdp-swatch] [data-pdp-section-wrapper] not found in response, falling back to full HTML');
            wrapper.innerHTML = html;
          }

          // Dispatch event so theme scripts (product-selector, etc.) can reinitialise
          wrapper.dispatchEvent(new CustomEvent('pdp:product-changed', {
            bubbles: true,
            detail: { productHandle: productHandle }
          }));

          // Update URL without navigation
          const url = new URL(window.location.href);
          url.searchParams.set('pdp_product', productHandle);
          window.history.replaceState({}, '', url.toString());
        })
        .catch(function (err) {
          console.error('[page-pdp-swatch] Error:', err);
        })
        .finally(function () {
          wrapper.style.opacity = '';
          wrapper.style.pointerEvents = '';
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageSwatches);
  } else {
    initPageSwatches();
  }
})();
